module.exports = __webpack_public_path__ + "static/media/06-news-detail2.a6a1aab9.png";